import {
  CandidateActionBlockedReason,
  CandidateActionRefusalReason,
} from '../../api/bookingApi.types';

/**
 * The copy key for why the booking read says the candidate may not change
 * their interview. A reason this page has not been taught gets the generic
 * line, which still tells them to contact the hiring team.
 */
export const blockedReasonKey = (reason: string | null): string | null => {
  switch (reason) {
    case null:
      return null;
    case CandidateActionBlockedReason.CUTOFF_PASSED:
      return 'publicScheduling.blockedCutoff';
    case CandidateActionBlockedReason.RESCHEDULE_LIMIT_REACHED:
      return 'publicScheduling.blockedLimit';
    case CandidateActionBlockedReason.STARTED:
      return 'publicScheduling.blockedStarted';
    default:
      return 'publicScheduling.blockedGeneric';
  }
};

/** Whether a refusal means the page is stale, so a reload is the remedy. */
export const isStaleRefusal = (reason: string): boolean =>
  reason === CandidateActionRefusalReason.BOOKING_CHANGED ||
  reason === CandidateActionRefusalReason.NO_LIVE_BOOKING;

/**
 * The copy key for a cancel or reschedule the server refused. The two stale
 * reasons share a line, because the remedy for both is to reload; the rest
 * are the same reasons the booking read gives, and say the same thing.
 */
export const refusalReasonKey = (reason: string): string =>
  isStaleRefusal(reason)
    ? 'publicScheduling.bookingChangedNotice'
    : (blockedReasonKey(reason) ?? 'publicScheduling.blockedGeneric');
